import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { LoanAgreementPreceptCreateInput, LoanAgreementPreceptUpdateInput } from '@libs/types/src/mado/input-type';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { LoanAgreementPreceptGridObject, LoanAgreementPreceptObject } from '@libs/types/src/mado/object-type/loan-agreement-precept.object';

@Injectable({ providedIn: 'root' })
export class LoanAgreementPreceptGqlService extends GqlServiceV2 {

    public getLoanAgreementPrecepts(input: GridInput | null, frag: string) {
        return this.query<LoanAgreementPreceptGridObject>(
            `
                query($input: GridInput!) {
                    loanAgreementPrecept {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createLoanAgreementPrecept(input: LoanAgreementPreceptCreateInput, frag: string) {
        return this.mutate<LoanAgreementPreceptObject>(
            `
                mutation($input: LoanAgreementPreceptCreateInput!) {
                    loanAgreementPrecept {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateLoanAgreementPrecept(input: LoanAgreementPreceptUpdateInput, frag: string) {
        return this.mutate<LoanAgreementPreceptObject>(
            `
                mutation($input: LoanAgreementPreceptUpdateInput!) {
                    loanAgreementPrecept {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteLoanAgreementPrecept(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    loanAgreementPrecept {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
